import { SelectChangeEvent } from '@mui/material';
import CONFIG from '~/Config/env.config';
import React from 'react';
import { PRIMARY_BLUE } from '~/Constants/Colors.constants';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  MenuItem,
  Select,
  Typography,
} from '~/UIKit';
import { makeStyles } from '~/UIKit/Style';
import { useMockMode, useNavigateToPartner } from '~/Hooks';
import { AccessRoles, FitogramVersion } from '~/Hooks/useHasAccess/accessList.types';

const useStyles = makeStyles(
  () => ({
    accordion: {
      marginTop: 30,
      borderLeft: `2px solid ${PRIMARY_BLUE}`,
    },
    accordionDetails: {
      '&>div': {
        display: 'flex',
        justifyContent: 'space-between',
        minHeight: 50,
        alignItems: 'center',
      },
    },
  }),
  { name: 'UserProfileMockAccessList' },
);

export const UserProfileMockAccessList = () => {
  const { classes } = useStyles();

  const { mockedAppView, mockedUserView, updateAppView, updateUserView } = useMockMode();

  const updateAppViewState = (e: SelectChangeEvent<FitogramVersion>) => {
    updateAppView(e.target.value as FitogramVersion);
  };
  const updateUserViewState = (e: SelectChangeEvent<AccessRoles>) => {
    updateUserView(e.target.value as AccessRoles);
  };

  const { navigateToPartnerHub } = useNavigateToPartner();

  const consoleLogAdminStuff = () => {
    // eslint-disable-next-line no-console
    console.log(process.env);
    // eslint-disable-next-line no-console
    console.log(CONFIG);
  };

  const breakNeo = () => {
    // eslint-disable-next-line no-console
    logSuperSecretText();
    // generate a code that will break the FE
    throw new Error('Neo is dead');
  };

  return (
    <>
      <Accordion classes={{ root: classes.accordion }}>
        <AccordionSummary aria-controls="panel1a-content" id="panel1a-header">
          <Typography>Super admin settings</Typography>
        </AccordionSummary>
        <AccordionDetails classes={{ root: classes.accordionDetails }}>
          <div>
            user view:
            <Select value={mockedUserView} onChange={updateUserViewState}>
              <MenuItem value={AccessRoles.FITOGRAM_SUPER_ADMIN}>Superadmin View</MenuItem>
              <MenuItem value={AccessRoles.PARTNER_TOOL_ADMIN}>USC Support Agent View</MenuItem>
              <MenuItem value={AccessRoles.ORGANISATION_MANAGER}>
                Partner Organisation Manager VIew
              </MenuItem>
              <MenuItem value={AccessRoles.FULL_ACCESS}>Partner Full Access View</MenuItem>
              <MenuItem value={AccessRoles.RESTRICTED}>Partner Restricted Access View</MenuItem>
              <MenuItem value={AccessRoles.TRAINER}>Partner Trainer View</MenuItem>
            </Select>
          </div>
          <div>
            app view:
            <Select value={mockedAppView} onChange={updateAppViewState}>
              <MenuItem value={FitogramVersion.Neo}>Full Fitogram Studio</MenuItem>
              <MenuItem value={FitogramVersion.PartnerTool}>Partner Portal Studio</MenuItem>
            </Select>
          </div>
        </AccordionDetails>
      </Accordion>

      <Accordion classes={{ root: classes.accordion }}>
        <AccordionSummary aria-controls="panel1a-content" id="panel1a-header">
          <Typography>Developer settings</Typography>
        </AccordionSummary>
        <AccordionDetails classes={{ root: classes.accordionDetails }}>
          <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
            <Button size="large" onClick={() => navigateToPartnerHub()}>
              Go To Partner Hub.
            </Button>
            <Button size="large" onClick={consoleLogAdminStuff}>
              console log stuff.
            </Button>
            <Button size="large" onClick={breakNeo}>
              break neo
            </Button>
          </div>
        </AccordionDetails>
      </Accordion>
    </>
  );
};

const logSuperSecretText = () => {
  // eslint-disable-next-line no-console
  console.log(
    `%c${atob(superSecretText1)}`,
    'font-weight: bold; background: linear-gradient(to right, black, darkblue, darkgreen, darkred); -webkit-background-clip: text; color: transparent;',
  );
  // eslint-disable-next-line no-console
  console.log(
    `%c${atob(superSecretText2)}`,
    'font-size: 8px; font-weight: bold; background: linear-gradient(to right, black, darkblue, darkgreen, darkred); -webkit-background-clip: text; color: transparent;',
  );
};

// eslint-disable-next-line max-len
const superSecretText1 = `TU1NTU1NTU1NTU1NTU1NWisrKysrKysrKytPTU1NTU1NTU1NTU1NTQpNTU1NTU1NTU1NTU0/KysrKysrKysrKysrKysrK01NTU1NTU1NTU1NCk1NTU1NTU1NTU1+OjorP01+KysrKysrKysrKysrKytNTU1NTU1NTU0KTU1NTU1NTU0/KysrSTo9JDg6fitPKzp+fj8rKytNKyskTU1NTU1NTQpNTU1NTU0rKysrKysrKysrKytPOjo3NytPfn5+fn5+Tjo3TU1NTU1NCk1NTU1NKysrKysrKysrKysrKysrKysrKysrJD8rKzd+WiR+TU1NTU0KTU1NTU83K0QrKysrKysrKysrKysrKysrKysrKysrKysrKysrTU1NTQpNTU0rK1paPysrKysrJE0rKysrKysrKysrKysrKysrKysrKyskTU1NCk1NKysrKysrWisrKysrKysrKysrKyQ4TisrKysrKysrKysrKytNTU0KTSsrKysrKysrKysrKysrKysrKysrKz8/K04rWkkrRCsrKz9OKytNTQpNKysrKysrKysrKysrKysrKz8/KysrKytPKysrTyQrKysrKysrWk1NCj8rKysrKysrKysrKysrKysrKysrKysrKysrKysrKytOSU4rKys4N00KKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrTQorKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKytNCisrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrK00KKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrTQpPRDc/JCsrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKytNCk8/N0Q/PysrKysrSSsrKysrKysrKysrKysrKysrKysrKysrKysrP00KTSsrKytEST9JSUk/ST8rKysrKyROKysrKysrKysrKysrKysrKytNTQpNPysrKysrKysrKysrP0lJST9JP0lJTisrTT9aKysrKzcrKysrK01NCk1NPT09TysrKysrKysrK1orKysrK1o/SUlJTj9JP0lJSUlJRCtNTU0KTU1NJD89TysrNyQrJCsrKysrKysrKysrKysrKzdJTzcrKzhJTU1NTQpNTU1NKysrPT09Pz09PSsrK0k4K08rKysrKysrKysrKysrK01NTU1NCk1NTU1NPysrKysrKysrPT09PT84PT0/SUk9PTcrKzc9TzdNTU1NTU0KTU1NTU1NTSsrKysrKysrKysrKysrPz09TitJPT09TlpNTU1NTU1NTQpNTU1NTU1NTU0/KysrKysrKysrKysrKysrKysrK09NTU1NTU1NTU1NCk1NTU1NTU1NTU1NTVorKysrKysrKysrKys/TU1NTU1NTU1NTU1NTU0KTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTQ==`;
// eslint-disable-next-line max-len
const superSecretText2 = `ICAgIF9fXyAgICAgICAgICBfXyAgX18gICAgICAgICAgICAgICAgICAgICAgICAgX19fXyAgICAgICAgICAgICAgX18gIF9fICAgICAgICAgX18gICAgICAgICAgICAgICBfXyAgICBfIAogICAvICAgfCAgX19fXyAgLyAvXy8gL18gIF9fX18gIF9fX18gIF9fICBfXyAgIC8gX18gXF9fICBfX19fX18gXy8gL18vIC9fICBfX18gIC8gL19fICBfX19fIF9fXyAgLyAvXyAgKF8pCiAgLyAvfCB8IC8gX18gXC8gX18vIF9fIFwvIF9fIFwvIF9fIFwvIC8gLyAvICAvIC8gLyAvIC8gLyAvIF9fIGAvIF9fLyBfXyBcLyBfIFwvIC8gXyBcLyBfXyBgX18gXC8gX18gXC8gLyAKIC8gX19fIHwvIC8gLyAvIC9fLyAvIC8gLyAvXy8gLyAvIC8gLyAvXy8gLyAgLyAvXy8gLyAvXy8gLyAvXy8gLyAvXy8gLyAvIC8gIF9fLyAvICBfXy8gLyAvIC8gLyAvIC8gLyAvIC8gIAovXy8gIHxfL18vIC9fL1xfXy9fLyAvXy9cX19fXy9fLyAvXy9cX18sIC8gICBcX19fXy9cX18sIC9cX18sXy9cX18vXy8gL18vXF9fXy9fL1xfX18vXy8gL18vIC9fL18vIC9fL18vICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgL19fX18vICAgICAgICAgL19fX18v`;
